import React from "react";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";


const BillPassingMenu = () => {
  useAuthRedirect();
  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">HO Bill Passing Menu
          </h2>
          <Time />
        </section>

     <div className="container">
      <table className="transaction-table ">
        <thead>
          <tr>
            <th className="table-header">HO Bill Passing Menu</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><Link to="/inventory/billPassingGRNView">GRN</Link></td>
          </tr>
          <tr>
          {/* <td><Link to="/inventory/billPassingGrnRejectionView">Rejected GRN</Link></td> */}
          </tr>
        </tbody>
      </table>
      </div>
    </div>
    </div>
  );
};

export default BillPassingMenu;
